<script setup>
import { ref } from "vue"
import FilterButton from "./FilterButton.vue"
import { useFilteredFeedStore } from "../utils/store.js"
const store = useFilteredFeedStore()

const toggled = ref(false)

defineProps({
	ages: {
		type: Array,
		required: true,
	}
})

</script>

<template>
	<div class="py-6 flex flex-col md:flex-row gap-8">
		<button class="md:pointer-events-none flex justify-between gap-4 items-start" @click="toggled = !toggled">
			<span class="inline-flex py-2">Age range?</span>
			<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6 md:hidden" :class="{ 'rotate-180': toggled }" >
				<path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
			</svg>
		</button>
		<div class="grow-1 hidden md:flex flex-wrap gap-2 -mx-3 md:mx-0" :class="{ '!flex': toggled }" >
			<FilterButton
				v-for="age in ages"
				:key="age.id"
				taxonomy="age-range"
				:term="age.slug"
				:label="age.name"
				/>
		</div>
	</div>
</template>